import React, { useState } from 'react';

/**
 * Renders a single event document — HTML content inline, or PDF in a new tab.
 */
export default function DocumentViewer({ document, code }) {
  const [pdfOpened, setPdfOpened] = useState(false);

  if (document.content_type === 'html') {
    return (
      <div
        className="document-html-content"
        // Admin-controlled content stored in DB — not user input
        dangerouslySetInnerHTML={{ __html: document.content }}
      />
    );
  }

  // PDF: open in browser tab via the API endpoint
  const pdfUrl = `/api/sign/${code}/documents/${document.id}/pdf`;

  return (
    <div className="document-pdf-wrapper">
      <div className="pdf-description">
        <svg width="40" height="40" viewBox="0 0 40 40" fill="none" aria-hidden="true">
          <rect width="40" height="40" rx="8" fill="#fee2e2"/>
          <path d="M12 8h16v24H12V8z" fill="white" stroke="#ef4444" strokeWidth="1.5"/>
          <path d="M12 8l6-6h10v6H12z" fill="#fca5a5"/>
          <text x="20" y="28" textAnchor="middle" fontSize="9" fill="#dc2626" fontWeight="bold">PDF</text>
        </svg>
        <div>
          <strong>{document.file_name || document.title}</strong>
          <p>Tap the button below to open this document in your browser, then return here to sign.</p>
        </div>
      </div>
      <a
        href={pdfUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="btn btn-outline btn-block"
        onClick={() => setPdfOpened(true)}
      >
        Open Document
      </a>
      {pdfOpened && (
        <p className="pdf-opened-note">
          Document opened — scroll down to provide your signature.
        </p>
      )}
    </div>
  );
}
